import { Category, FiltersType } from '@/types';
import { isEqual } from 'lodash';

export const checkIsValueEqual = (filters: FiltersType, newFiltersValue: Partial<FiltersType>) => {
  let isEquals = false;

  outerBlock: for (const [newFilterKey, newFilterValue] of Object.entries(newFiltersValue)) {
    for (const [filterKey, filterValue] of Object.entries(filters)) {
      if (newFilterKey === filterKey) {
        if (newFilterKey === 'currentPage' && filterValue !== newFilterValue) {
          isEquals = false;
          break outerBlock;
        }

        if (newFilterKey === 'offerTypeValue' && filterValue !== newFilterValue) {
          isEquals = false;
          break outerBlock;
        }

        if (newFilterKey === 'unitListValue') {
          if ((filterValue as string[]).length !== (newFilterValue as string[]).length) {
            isEquals = false;
            break outerBlock;
          }
          if (!isEqual(filterValue, newFilterValue)) {
            isEquals = false;
            break outerBlock;
          }
        }

        if (
          newFilterKey === 'areaValue' ||
          newFilterKey === 'roomNumberValue' ||
          newFilterKey === 'priceValue' ||
          newFilterKey === 'rentPriceValue'
        ) {
          if (
            (filterValue as number[])[0] !== (newFilterValue as number[])[0] ||
            (filterValue as number[])[1] !== (newFilterValue as number[])[1]
          ) {
            isEquals = false;
            break outerBlock;
          }
        }

        if (newFilterKey === 'categoriesValue' || newFilterKey === 'equipmentValue') {
          if ((filterValue as Category[]).length !== (newFilterValue as Category[]).length) {
            isEquals = false;
            break outerBlock;
          }
          if (!isEqual(filterValue, newFilterValue)) {
            isEquals = false;
            break outerBlock;
          }
        }
      }
    }
  }

  return isEquals;
};
